<app-source-panel
  [sourceContext]="sourceContext"
  [configdata]="configdata"
  [tenantId]="tenantId"
  [domainId]="domainId"
  (closePanelEvent)="closePanelEvent.emit()">
</app-source-panel>
